export type CookieOptions = {
  domain?: string;
  secure?: boolean;
  expires?: Date | number;
};

export function setCookie(
  name: string,
  value: string,
  opts: CookieOptions = {}
): void {
  const d = opts.domain ? `; domain=${opts.domain}` : "";
  const s = opts.secure ? "; Secure" : "";
  const e =
    opts.expires instanceof Date
      ? `; expires=${opts.expires.toUTCString()}`
      : typeof opts.expires === "number"
      ? `; max-age=${Math.floor(opts.expires * 24 * 60 * 60)}` // días → segundos
      : "";
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/${d}${s}${e}`;
}

export function getCookie(name: string): string | null {
  const parts = document.cookie.split("; ");
  for (const p of parts) {
    if (p.startsWith(name + "=")) {
      return decodeURIComponent(p.split("=")[1] || "");
    }
  }
  return null;
}
